<template>
  <v-layout row wrap v-if="article" class="flash-article">
    <v-flex xs12 class="px-0">
      <mv-default-row>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card light color="amber lighten-3">
              <v-subheader>
                {{article.date}}&nbsp;&nbsp;{{article.title}}
                <v-spacer></v-spacer>
                <v-btn flat icon @click="$emit('closeArticle', article)">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-subheader>
              <v-card-text v-html="article.content"></v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </mv-default-row>
    </v-flex>
  </v-layout>
</template>

<script>

export default {
  name: 'FlashArticle',
  props: ['article']
}
</script>

<style lang="css">
.flash-article {
}
</style>
